module.exports = __webpack_public_path__ + "assets/GoldAlpha2x.897d5e216379c02cdad35d609a7f323d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldAlpha2x.png
// module id = 804
// module chunks = 0